import { Footer } from "./footer";
import { SignIn } from "./sign-in";

const LoginPage = () => {
  return (
    <>
      <SignIn />
      <Footer />
    </>
  );
};
export default LoginPage;
